let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("68cVV")]).then(() => parcelRequire('4Accx'));